module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "modul-belajar-2022"
    }
  }, [_c('v-breadcrumbs', {
    attrs: {
      "items": [{
          text: 'Dashboard',
          to: {
            path: '/'
          }
        },
        {
          text: 'Modul Pembelajaran'
        } ],
      "divider": "|"
    }
  }), _vm._v(" "), _c('h3', {
    staticClass: "header-text font-weight-bold"
  }, [_vm._v("Modul Pembelajaran")]), _vm._v(" "), _c('v-card', [_c('v-card-title', [_vm._v("\n            Daftar Modul\n            "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "align-center text-body-2 blew white--text mr-2",
    attrs: {
      "text": ""
    },
    on: {
      "click": function($event) {
        return _vm.createModulBelajar()
      }
    }
  }, [_c('v-icon', {
    staticClass: "pr-2",
    attrs: {
      "small": ""
    }
  }, [_vm._v("mdi-plus-circle")]), _vm._v("\n                Modul\n            ")], 1), _vm._v(" "), _c('v-btn', {
    staticClass: "align-center text-body-2 blew white--text mr-2",
    attrs: {
      "text": ""
    },
    on: {
      "click": function($event) {
        return _vm.reportModule()
      }
    }
  }, [_c('v-icon', {
    staticClass: "mr-2",
    attrs: {
      "small": ""
    }
  }, [_vm._v("mdi-chart-bell-curve")]), _vm._v("\n                Lihat Laporan\n            ")], 1)], 1), _vm._v(" "), _c('v-card-text', {
    staticClass: "px-0 py-3 border-top-1"
  }, [_c('div', {
    staticClass: "mt-2"
  }, [_c('v-row', {
    staticClass: "d-flex align-center flex-wrap justify-center no-gutters gap-10"
  }, [_c('v-col', [_c('v-autocomplete', {
    attrs: {
      "height": "36px",
      "hide-details": "",
      "placeholder": "Kelas",
      "dense": "",
      "clearable": "",
      "outlined": "",
      "items": _vm.gradeList
    },
    on: {
      "change": function($event) {
        return _vm.fetchData()
      }
    },
    model: {
      value: (_vm.grade),
      callback: function($$v) {
        _vm.grade = $$v
      },
      expression: "grade"
    }
  })], 1), _vm._v(" "), _c('v-col', [_c('v-autocomplete', {
    attrs: {
      "height": "36px",
      "hide-details": "",
      "placeholder": "Kurikulum",
      "dense": "",
      "clearable": "",
      "outlined": "",
      "items": [{
          text: 'KM',
          value: 'KM'
        },
        {
          text: 'K13',
          value: 'K13'
        },
        {
          text: 'K13 IPA',
          value: 'SAINTEK'
        },
        {
          text: 'K13 IPS',
          value: 'SOSHUM'
        },
        {
          text: 'TKA',
          value: 'TKA'
        } ],
      "item-text": "text",
      "item-value": "value"
    },
    on: {
      "change": function($event) {
        return _vm.fetchData()
      }
    },
    model: {
      value: (_vm.kurikulum),
      callback: function($$v) {
        _vm.kurikulum = $$v
      },
      expression: "kurikulum"
    }
  })], 1), _vm._v(" "), _c('v-col', [_c('v-autocomplete', {
    attrs: {
      "height": "36px",
      "hide-details": "",
      "placeholder": "Mata Pelajaran",
      "clearable": "",
      "dense": "",
      "outlined": "",
      "items": _vm.mapelList,
      "item-text": "nama",
      "item-value": "nama"
    },
    on: {
      "change": function($event) {
        return _vm.getMapelByName()
      }
    },
    model: {
      value: (_vm.subject),
      callback: function($$v) {
        _vm.subject = $$v
      },
      expression: "subject"
    }
  })], 1), _vm._v(" "), _c('v-col', [_c('v-select', {
    attrs: {
      "height": "36px",
      "hide-details": "",
      "placeholder": "Bab",
      "dense": "",
      "clearable": "",
      "outlined": "",
      "items": _vm.topics,
      "item-text": "nama",
      "item-value": "nama"
    },
    on: {
      "change": function($event) {
        return _vm.fetchData()
      }
    },
    model: {
      value: (_vm.bab),
      callback: function($$v) {
        _vm.bab = $$v
      },
      expression: "bab"
    }
  })], 1), _vm._v(" "), _c('v-col', [_c('v-select', {
    attrs: {
      "height": "36px",
      "hide-details": "",
      "placeholder": "Status",
      "dense": "",
      "clearable": "",
      "outlined": "",
      "items": [{
          text: 'Draft',
          value: 'DRAFT'
        },
        {
          text: 'Review',
          value: 'REVIEW'
        },
        {
          text: 'Publikasi',
          value: 'PUBLISHED'
        } ],
      "item-text": "text",
      "item-value": "value"
    },
    on: {
      "change": function($event) {
        return _vm.fetchData()
      }
    },
    model: {
      value: (_vm.status),
      callback: function($$v) {
        _vm.status = $$v
      },
      expression: "status"
    }
  })], 1), _vm._v(" "), _c('v-col', [_c('v-card', {
    staticClass: "px-4 py-3 text-center",
    staticStyle: {
      "border": "2px solid #f0f3f9"
    },
    attrs: {
      "outlined": ""
    }
  }, [_c('div', {
    staticClass: "font-weight-500"
  }, [_vm._v("Total Modul")]), _vm._v(" "), _c('div', {
    staticClass: "font-weight-700 mt-1",
    staticStyle: {
      "font-size": "24px"
    }
  }, [(_vm.isFetchingCount) ? _c('v-progress-circular', {
    attrs: {
      "indeterminate": "",
      "size": "20",
      "width": "2",
      "color": "blew"
    }
  }) : [_vm._v("\n                                    " + _vm._s(_vm.total_modules) + "\n                                ")]], 2)])], 1), _vm._v(" "), _c('v-col', [_c('v-card', {
    staticClass: "px-4 py-3 text-center",
    staticStyle: {
      "border": "2px solid #f0f3f9"
    },
    attrs: {
      "outlined": ""
    }
  }, [_c('div', {
    staticClass: "font-weight-500"
  }, [_vm._v("\n                                Modul Terpublikasi\n                            ")]), _vm._v(" "), _c('div', {
    staticClass: "font-weight-700 mt-1",
    staticStyle: {
      "font-size": "24px"
    }
  }, [(_vm.isFetchingCount) ? _c('v-progress-circular', {
    attrs: {
      "indeterminate": "",
      "size": "20",
      "width": "2",
      "color": "blew"
    }
  }) : [_vm._v("\n                                    " + _vm._s(_vm.total_published) + "\n                                    "), _c('span', {
    staticClass: "font-size-14"
  }, [_vm._v("\n                                        Modul\n                                    ")])]], 2)])], 1)], 1)], 1)]), _vm._v(" "), _c('app-datatable', {
    attrs: {
      "items": _vm.Moduls,
      "headers": _vm.headers,
      "table-loading": _vm.isFetching,
      "hasAction": true,
      "has-custom-pagination": true,
      "custom-pagination-total-items": _vm.totalItems,
      "custom-pagination-per-page": _vm.pagination.perPage,
      "custom-pagination-total-pages": _vm.total_pages,
      "custom-pagination-current-page": _vm.pagination.currentPage,
      "custom-pagination-sort-mode": _vm.pagination.sortMode
    },
    on: {
      "selected": function($event) {
        _vm.selectedRow = $event
      },
      "dblClicked": function($event) {
        return _vm.editModulBelajar()
      },
      "duplicateClicked": function($event) {
        return _vm.duplicateItem()
      },
      "deleted": function($event) {
        _vm.dialogConfirm.function = $event;
        _vm.dialogConfirm.title =
          'Apakah anda yakin akan menghapus Modul Belajar ini?';
        _vm.dialogConfirm.open = true;
      },
      "changePage": function($event) {
        _vm.pagination = Object.assign({}, _vm.pagination,
          {currentPage: $event})
      },
      "changeSortMode": function($event) {
        _vm.pagination = Object.assign({}, _vm.pagination,
          {sortMode: $event})
      },
      "doSearch": function($event) {
        _vm.search = $event;
        _vm.fetchData();
      }
    },
    scopedSlots: _vm._u([{
      key: "no-data",
      fn: function() {
        return [_c('div', {
          staticClass: "py-10 text-center"
        }, [_c('v-icon', {
          attrs: {
            "size": "48",
            "color": "grey lighten-1"
          }
        }, [_vm._v("\n                        " + _vm._s(_vm.fetchError ?
          "mdi-alert-circle-outline" :
          "mdi-folder-open-outline") + "\n                    ")]), _vm._v(" "), _c('div', {
          staticClass: "font-weight-bold mt-3 black--text"
        }, [_vm._v("\n                        " + _vm._s(_vm.emptyState.title) + "\n                    ")]), _vm._v(" "), _c('div', {
          staticClass: "mt-1"
        }, [_vm._v(_vm._s(_vm.emptyState.subtitle))]), _vm._v(" "), (_vm.fetchError) ? _c('v-btn', {
          staticClass: "mt-4 blew white--text",
          attrs: {
            "depressed": "",
            "small": ""
          },
          on: {
            "click": function($event) {
              return _vm.fetchData()
            }
          }
        }, [_vm._v("\n                        Coba Lagi\n                    ")]) : (_vm.hasDropdownFilter) ? _c('v-btn', {
          staticClass: "mt-4",
          attrs: {
            "depressed": "",
            "small": ""
          },
          on: {
            "click": function($event) {
              return _vm.resetFilter()
            }
          }
        }, [_vm._v("\n                        Reset Filter\n                    ")]) : (!_vm.hasActiveFilter) ? _c('v-btn', {
          staticClass: "mt-4 blew white--text",
          attrs: {
            "depressed": "",
            "small": ""
          },
          on: {
            "click": function($event) {
              return _vm.createModulBelajar()
            }
          }
        }, [_c('v-icon', {
          staticClass: "pr-2",
          attrs: {
            "small": ""
          }
        }, [_vm._v("mdi-plus-circle")]), _vm._v("\n                        Tambah Modul\n                    ")], 1) : _vm._e()], 1)]
      },
      proxy: true
    }])
  })], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "persistent": "",
      "max-width": "506px"
    },
    model: {
      value: (_vm.dialogConfirm.open),
      callback: function($$v) {
        _vm.$set(_vm.dialogConfirm, "open", $$v)
      },
      expression: "dialogConfirm.open"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "text-h5",
    staticStyle: {
      "word-break": "break-word !important"
    }
  }, [_vm._v("\n                " + _vm._s(_vm.dialogConfirm.title) + "\n            ")]), _vm._v(" "), _c('v-card-text', [_vm._v("\n                " + _vm._s(_vm.dialogConfirm.subtitle) + "\n            ")]), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "darkFade",
      "text": ""
    },
    on: {
      "click": function($event) {
        _vm.dialogConfirm.open = false
      }
    }
  }, [_vm._v("\n                    Batal\n                ")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "blew",
      "text": ""
    },
    on: {
      "click": function($event) {
        _vm.deleteModulBelajar(_vm.dialogConfirm.function);
        _vm.dialogConfirm.open = false;
      }
    }
  }, [_vm._v("\n                    OK\n                ")])], 1)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "persistent": "",
      "max-width": "506px"
    },
    model: {
      value: (_vm.dialogConfirm2.open),
      callback: function($$v) {
        _vm.$set(_vm.dialogConfirm2, "open", $$v)
      },
      expression: "dialogConfirm2.open"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "text-h5",
    staticStyle: {
      "word-break": "break-word !important"
    }
  }, [_vm._v("\n                " + _vm._s(_vm.dialogConfirm2.title) + "\n            ")]), _vm._v(" "), _c('v-card-text', [_vm._v("\n                " + _vm._s(_vm.dialogConfirm2.subtitle) + "\n            ")]), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "darkFade",
      "text": ""
    },
    on: {
      "click": function($event) {
        _vm.dialogConfirm2.open = false
      }
    }
  }, [_vm._v("\n                    Batal\n                ")]), _vm._v(" "), (_vm.dialogConfirm2.function == 'onDuplicateConfirm') ? _c('v-btn', {
    attrs: {
      "color": "blew",
      "text": ""
    },
    on: {
      "click": _vm.onDuplicateConfirm
    }
  }, [_vm._v("\n                    OK\n                ")]) : _vm._e(), _vm._v(" "), (_vm.dialogConfirm2.function == 'onDuplicateCancel') ? _c('v-btn', {
    attrs: {
      "color": "blew",
      "text": ""
    },
    on: {
      "click": _vm.onDuplicateCancel
    }
  }, [_vm._v("\n                    OK\n                ")]) : _vm._e()], 1)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "transition": "dialog-top-transition",
      "width": "900px",
      "persistent": "",
      "height": "168px",
      "scrollable": ""
    },
    on: {
      "click:outside": function($event) {
        _vm.dialogConfirm2.title = 'Yakin ingin membatalkan duplikasi ?';
        _vm.dialogConfirm2.open = true;
        _vm.dialogConfirm2.function = 'onDuplicateCancel';
      }
    },
    model: {
      value: (_vm.showModal),
      callback: function($$v) {
        _vm.showModal = $$v
      },
      expression: "showModal"
    }
  }, [_c('v-card', [_c('v-card-title', {
    attrs: {
      "width": "100%"
    }
  }, [_vm._v("\n                Detail Duplikat Modul\n                "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "small": "",
      "icon": ""
    },
    on: {
      "click": function($event) {
        _vm.dialogConfirm2.title =
          'Yakin ingin membatalkan duplikasi ?';
        _vm.dialogConfirm2.open = true;
        _vm.dialogConfirm2.function = 'onDuplicateCancel';
      }
    }
  }, [_c('v-icon', [_vm._v("mdi-close-circle")])], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-text', {
    staticClass: "py-4 px-6"
  }, [_c('v-form', {
    ref: "duplicateForm",
    attrs: {
      "lazy-validation": ""
    }
  }, [_c('v-list-item', {
    staticClass: "pa-0",
    attrs: {
      "two-line": ""
    }
  }, [_c('v-list-item-content', {
    staticClass: "pa-0"
  }, [_c('v-list-item-title', {
    staticClass: "font-weight-bold pb-2"
  }, [_vm._v("\n                                Nama Modul "), _c('span', {
    staticClass: "red--text"
  }, [_vm._v("*")])]), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "placeholder": "Nama Modul Belajar",
      "outlined": "",
      "rules": [
        function (v) { return !!(v && v.trim()) ||
        'Nama Modul wajib diisi'; } ]
    },
    model: {
      value: (_vm.details.name),
      callback: function($$v) {
        _vm.$set(_vm.details, "name", $$v)
      },
      expression: "details.name"
    }
  })], 1)], 1), _vm._v(" "), _c('v-list-item', {
    staticClass: "pa-0",
    attrs: {
      "two-line": ""
    }
  }, [_c('v-list-item-content', {
    staticClass: "pa-0"
  }, [_c('v-list-item-title', {
    staticClass: "font-weight-bold pb-2"
  }, [_vm._v("\n                                Jenjang "), _c('span', {
    staticClass: "red--text"
  }, [_vm._v("*")])]), _vm._v(" "), _c('v-radio-group', {
    attrs: {
      "row": "",
      "rules": [
        function (v) { return !!v || 'Jenjang wajib dipilih'; } ]
    },
    on: {
      "change": function($event) {
        return _vm.resetKelas()
      }
    },
    model: {
      value: (_vm.details.jenjang),
      callback: function($$v) {
        _vm.$set(_vm.details, "jenjang", $$v)
      },
      expression: "details.jenjang"
    }
  }, _vm._l((_vm.jenjangList), function(item) {
    return _c('v-radio', {
      key: item,
      staticClass: "jenjang-selection",
      attrs: {
        "label": item,
        "value": item,
        "active-class": "act-radio-btn"
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), (_vm.details.jenjang) ? _c('v-list-item', {
    staticClass: "pa-0",
    attrs: {
      "two-line": ""
    }
  }, [_c('v-list-item-content', {
    staticClass: "pa-0"
  }, [_c('v-list-item-title', {
    staticClass: "font-weight-bold pb-2"
  }, [_vm._v("\n                                Kelas "), _c('span', {
    staticClass: "red--text"
  }, [_vm._v("*")])]), _vm._v(" "), _c('v-input', {
    attrs: {
      "value": _vm.details.grades,
      "rules": [
        function (v) { return (v && v.length > 0) ||
        'Kelas wajib dipilih minimal satu'; } ]
    }
  }, [_c('div', {
    staticClass: "d-inline"
  }, _vm._l((_vm.gradesByJenjang[
    _vm.details.jenjang
  ] || []), function(grade) {
    return _c('v-checkbox', {
      key: grade,
      staticClass: "pa-2 ma-0 d-inline-flex",
      attrs: {
        "label": String(grade),
        "value": grade,
        "hide-details": ""
      },
      model: {
        value: (_vm.details.grades),
        callback: function($$v) {
          _vm.$set(_vm.details, "grades", $$v)
        },
        expression: "details.grades"
      }
    })
  }), 1)])], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-list-item', {
    staticClass: "pa-0",
    attrs: {
      "two-line": ""
    }
  }, [_c('v-list-item-content', {
    staticClass: "pa-0"
  }, [_c('v-list-item-title', {
    staticClass: "font-weight-bold pb-2"
  }, [_vm._v("\n                                Status User ")]), _c('v-radio-group', {
    attrs: {
      "row": ""
    },
    model: {
      value: (_vm.details.status_user),
      callback: function($$v) {
        _vm.$set(_vm.details, "status_user", $$v)
      },
      expression: "details.status_user"
    }
  }, [_c('v-radio', {
    staticClass: "jenjang-selection",
    attrs: {
      "id": "live_class_type_free",
      "label": "FREE",
      "value": "FREE",
      "active-class": "act-radio-btn"
    }
  }), _vm._v(" "), _c('v-radio', {
    staticClass: "jenjang-selection",
    attrs: {
      "id": "live_class_type_premium",
      "label": "PREMIUM",
      "value": "PREMIUM",
      "active-class": "act-radio-btn"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-list-item', {
    staticClass: "pa-0",
    attrs: {
      "two-line": ""
    }
  }, [_c('v-list-item-content', {
    staticClass: "pa-0"
  }, [_c('v-list-item-title', {
    staticClass: "font-weight-bold pb-2"
  }, [_vm._v("\n                                Kurikulum "), _c('span', {
    staticClass: "red--text"
  }, [_vm._v("*")])]), _vm._v(" "), _c('v-input', {
    attrs: {
      "value": _vm.details.kurikulum,
      "rules": [
        function (v) { return !!v || 'Kurikulum wajib dipilih'; } ]
    }
  }, [_c('div', [_c('v-checkbox', {
    staticClass: "pa-2 ma-0 d-inline-flex",
    attrs: {
      "label": "KM",
      "value": "KM",
      "hide-details": ""
    },
    model: {
      value: (_vm.details.kurikulum),
      callback: function($$v) {
        _vm.$set(_vm.details, "kurikulum", $$v)
      },
      expression: "details.kurikulum"
    }
  }), _vm._v(" "), _c('v-checkbox', {
    staticClass: "pa-2 ma-0 d-inline-flex",
    attrs: {
      "label": "K13",
      "value": "K13",
      "hide-details": ""
    },
    model: {
      value: (_vm.details.kurikulum),
      callback: function($$v) {
        _vm.$set(_vm.details, "kurikulum", $$v)
      },
      expression: "details.kurikulum"
    }
  }), _vm._v(" "), _c('v-checkbox', {
    staticClass: "pa-2 ma-0 d-inline-flex",
    attrs: {
      "label": "K13 IPA",
      "value": "saintek",
      "hide-details": ""
    },
    model: {
      value: (_vm.details.kurikulum),
      callback: function($$v) {
        _vm.$set(_vm.details, "kurikulum", $$v)
      },
      expression: "details.kurikulum"
    }
  }), _vm._v(" "), _c('v-checkbox', {
    staticClass: "pa-2 ma-0 d-inline-flex",
    attrs: {
      "label": "K13 IPS",
      "value": "soshum",
      "hide-details": ""
    },
    model: {
      value: (_vm.details.kurikulum),
      callback: function($$v) {
        _vm.$set(_vm.details, "kurikulum", $$v)
      },
      expression: "details.kurikulum"
    }
  }), _vm._v(" "), _c('v-checkbox', {
    staticClass: "pa-2 ma-0 d-inline-flex",
    attrs: {
      "label": "TKA",
      "value": "TKA",
      "hide-details": ""
    },
    model: {
      value: (_vm.details.kurikulum),
      callback: function($$v) {
        _vm.$set(_vm.details, "kurikulum", $$v)
      },
      expression: "details.kurikulum"
    }
  })], 1)])], 1)], 1), _vm._v(" "), _c('v-list-item', {
    staticClass: "pa-0",
    attrs: {
      "two-line": ""
    }
  }, [_c('v-list-item-content', {
    staticClass: "pa-0"
  }, [_c('v-list-item-title', {
    staticClass: "font-weight-bold pb-2"
  }, [_vm._v("\n                                Semester "), _c('span', {
    staticClass: "red--text"
  }, [_vm._v("*")])]), _vm._v(" "), _c('v-radio-group', {
    attrs: {
      "row": "",
      "rules": [
        function (v) { return !!v || 'Semester wajib dipilih'; } ]
    },
    model: {
      value: (_vm.details.semester),
      callback: function($$v) {
        _vm.$set(_vm.details, "semester", $$v)
      },
      expression: "details.semester"
    }
  }, [_c('v-radio', {
    staticClass: "jenjang-selection",
    attrs: {
      "label": "Ganjil",
      "value": "GANJIL",
      "active-class": "act-radio-btn"
    }
  }), _vm._v(" "), _c('v-radio', {
    staticClass: "jenjang-selection",
    attrs: {
      "label": "Genap",
      "value": "GENAP",
      "active-class": "act-radio-btn"
    }
  })], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', {
    staticClass: "justify-end"
  }, [_c('v-btn', {
    attrs: {
      "text": "",
      "elevation": "0"
    },
    on: {
      "click": function($event) {
        _vm.dialogConfirm2.title =
          'Yakin ingin membatalkan duplikasi ?';
        _vm.dialogConfirm2.open = true;
        _vm.dialogConfirm2.function = 'onDuplicateCancel';
      }
    }
  }, [_vm._v("Batal")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "dark": "",
      "color": "blew"
    },
    on: {
      "click": function($event) {
        return _vm.confirmDuplicate()
      }
    }
  }, [_vm._v("Simpan")])], 1)], 1)], 1), _vm._v(" "), (_vm.isLoading) ? _c('app-spinner') : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-46146c86","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/modules/modul_belajar_2022/components/ModulBelajar.vue
// module id = 1867
// module chunks = 1